export const HOME_MAP_DEFAULT_CENTER = { lat: 40.7128, lng: -74.006 };

function isUsableCenter(center) {
  return (
    center &&
    typeof center === "object" &&
    typeof center.lat === "number" &&
    typeof center.lng === "number" &&
    Number.isFinite(center.lat) &&
    Number.isFinite(center.lng)
  );
}

export function resolveHomeMapCenterState({
  mapCenter = null,
  routeMapCenter = null,
  userLocation = null,
  defaultCenter = HOME_MAP_DEFAULT_CENTER,
  permissionState = "unknown",
  isLocating = false,
  geoError = null,
  hasUserDraggedMap = false,
  isUncoverSeeding = false,
  uncoverAnchorCenter = null,
  preferMapCenter = false,
  isResolvingMapCenter = false,
  waitCapReached = false,
} = {}) {
  const preferredCenter =
    (isUsableCenter(routeMapCenter) && routeMapCenter) ||
    (preferMapCenter && isUsableCenter(mapCenter) && mapCenter) ||
    (isUsableCenter(userLocation) && userLocation) ||
    (isUsableCenter(mapCenter) && mapCenter) ||
    null;
  // Once the startup wait cap elapses, stop deferring on a still-unresolved
  // location. We fall back to the app default center so downstream consumers
  // (map render + the nearby-discovery/gems fetch) can proceed instead of
  // hanging behind a slow GPS prompt or a slow center cascade. A real center
  // (GPS/GeoIP) still takes over via preferredCenter once it lands.
  const canWaitForGrantedLocation =
    !preferredCenter &&
    !geoError &&
    !waitCapReached &&
    (permissionState === "unknown" || permissionState === "granted" || isLocating);
  const canWaitForMapCenter =
    !preferredCenter && !waitCapReached && Boolean(isResolvingMapCenter);
  const shouldDeferMapRender =
    (canWaitForGrantedLocation || canWaitForMapCenter) && !hasUserDraggedMap;
  const effectiveCenter =
    preferredCenter ||
    (canWaitForGrantedLocation || canWaitForMapCenter ? null : defaultCenter);
  const mapRenderCenter =
    isUncoverSeeding && isUsableCenter(uncoverAnchorCenter)
      ? uncoverAnchorCenter
      : hasUserDraggedMap
        ? undefined
        : effectiveCenter;

  return {
    effectiveCenter,
    mapRenderCenter,
    deferMapRender: Boolean(shouldDeferMapRender),
  };
}

export function resolveHomeMapPassiveQuickFindCenter({
  effectiveCenter = null,
  routeMapCenter = null,
  userLocation = null,
} = {}) {
  if (isUsableCenter(routeMapCenter) || isUsableCenter(userLocation)) {
    return null;
  }
  return isUsableCenter(effectiveCenter) ? effectiveCenter : null;
}
